import { computed, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';

export const FUNC_CASES = [
  { func: '11', name: '11 · 握手与 SM2 公钥' },
  { func: '224', name: '224 · 在线车型匹配' },
  { func: '250', name: '250 · 扩展握手与车型支持版本' },
];

export function useMazdaApiTest(mazdaPost, getServerName = () => '') {
  const running = ref(false);
  const target = ref('active');
  const results = ref([]);
  const lastRunAt = ref('');
  const runServer = ref('');
  const passCount = computed(() => results.value.filter((row) => row.status === 'pass').length);
  const failCount = computed(() => results.value.filter((row) => row.status === 'fail').length);

  const resetResults = () => {
    if (running.value) return;
    results.value = [];
    lastRunAt.value = '';
    runServer.value = '';
  };

  const run = async (cases) => {
    if (running.value) return;
    running.value = true;
    const selectedTarget = target.value;
    runServer.value = getServerName();
    lastRunAt.value = new Date().toLocaleString();
    results.value = cases.map((item) => reactive({
      ...item, status: 'pending', durationMs: null, detail: '',
      checks: [], sample: null, decoded: null, response: null, dll: null,
    }));
    try {
      for (const row of results.value) {
        row.status = 'running';
        const started = Date.now();
        try {
          let response;
          try {
            response = await mazdaPost('pluginFuncTest', {
              func: row.func, target: selectedTarget,
            }, { timeout: 120000, serverName: runServer.value });
          } catch (error) {
            if (!error?.response) throw error;
            response = error.response;
          }
          const data = response?.data || {};
          row.response = data;
          row.sample = data.test?.sample || null;
          row.decoded = data.test?.decoded || null;
          row.dll = data.dll || null;
          row.checks = Array.isArray(data.test?.checks) ? data.test.checks : [];
          const passed = response?.status === 200 && data.code === 0 &&
            data.test?.func === row.func && data.test?.passed === true &&
            row.checks.length > 0 && row.checks.every((item) => item.passed === true);
          row.status = passed ? 'pass' : 'fail';
          const failures = row.checks.filter((item) => item.passed !== true).map((item) => item.name);
          row.detail = failures.length ? failures.join('；') :
            passed ? '功能返回及数据校验通过' :
              data.message || '后端未返回有效自检结果，请更新后端后重试';
        } catch (error) {
          row.status = 'fail';
          row.detail = error?.message || '网络请求失败';
        } finally {
          row.durationMs = Date.now() - started;
        }
      }
    } finally {
      running.value = false;
    }
    ElMessage[failCount.value ? 'error' : 'success'](
      `自检完成：通过 ${passCount.value} 项，失败 ${failCount.value} 项`,
    );
  };

  const runOne = (func) => {
    const item = FUNC_CASES.find((entry) => entry.func === func);
    return item ? run([item]) : Promise.resolve();
  };
  return { running, target, results, lastRunAt, runServer, passCount, failCount,
    runOne, resetResults };
}
